import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import {connect} from 'react-redux'
import objectPath from 'object-path'
import {Link} from 'react-router-dom'
import styles from './Header.css'
import {toggleDrawer} from 'mb-app-common/store/actions/nav-draw'


const HeaderComponent = (props) => {
	const loggedIn = !!props.account

	return (
		<header className="container-fluid">
			<div id={styles.logoRow} className="row logo-row extra-container-padding">
				<div className="col-xs-10 col-sm-4">
					<Link to="/">
						<div className={`sprite-homepage-TopLogo-small2x ${styles.logo}`}></div>
					</Link>
				</div>
				<div className={`col-xs-2 col-sm-8 ${styles.phoneNumber}`}>
					<span className="hidden-xs">
						<span className={`${styles.icon} sprite-homepage-Header-PhoneIcon-Small2x`}></span>
						08 8215 7500
					</span>
					<a href="tel:0882157500" className="visible-xs-block"><span className={`${styles.icon} sprite-homepage-Header-PhoneIcon-Small2x`}></span></a>
				</div>
			</div>
			<div id={styles.clientDetailsRow} className="row extra-container-padding navbar">
				<div className={`col-xs-2 ${styles.sidebarToggleWrapper}`}>
					<button type="button" className={`navbar-toggle ${styles.navbarToggle}`} onClick={() => props.dispatch(toggleDrawer())}>
						<span className={`icon-bar ${styles.iconBar}`}></span>
						<span className={`icon-bar ${styles.iconBar}`}></span>
						<span className={`icon-bar ${styles.iconBar}`}></span>
					</button>
				</div>

				<div className={`${styles.greeting} col-sm-6`}>
					<span className={`${styles.icon} sprite-homepage-Header-ClientIcon2x`}></span>

					<Choose>
						<When condition={loggedIn}>
							<span>{`Hello ${props.name}. `}</span>
						</When>
						<Otherwise>
							<span>Welcome to the MyBudget Client website, </span>
						</Otherwise>
					</Choose>

					<span className="date-string">It's {moment().format('dddd Do MMMM YYYY, h:mma')}.</span>
				</div>
				<If condition={loggedIn}>
					<div className={`${styles.accountNumberLogout} col-xs-10 col-sm-12 col-md-6`}>
						<div className={styles.accountNumber}>
							<span>Account <span className="hidden-xs">Number</span></span>
							{props.account}
						</div>
						<div className={styles.logout}>
							<Link to="/logout">Logout</Link>
							<span className={`${styles.icon} sprite-homepage-Header-LockIcon2x`}></span>
						</div>
					</div>
				</If>

			</div>
		</header>
	)
}

HeaderComponent.propTypes = {
	dispatch: PropTypes.func,
	name: PropTypes.string,
	account: PropTypes.string,
	clientIndex: PropTypes.oneOf(['1', '2'])
}

export const Header = HeaderComponent

export default connect((state) => {
	return {
		name: objectPath.get(state.Auth, ['token', 'nickname']),
		account: objectPath.get(state.Auth, ['token', 'accountNumber']),
		clientIndex: objectPath.get(state.Auth, ['token', 'clientIndex'])
	}
})(HeaderComponent)



// WEBPACK FOOTER //
// ./client/components/layout/Header/index.js